(() => {
  if (window.oeHeroVideoInitialized) return;
  window.oeHeroVideoInitialized = true;
  const instances = new WeakMap();

  function initialize(hero) {
    if (instances.has(hero) || !hero.querySelector('[data-hero-video]')) return;
    const controller = new AbortController();
    const { signal } = controller;
    const mobile = matchMedia('(max-width: 767px)');
    const playRequests = new WeakMap();
    let idleRequest;
    let video;

    const clear = () => {
      hero.removeAttribute('data-hero-video-playing');
      if (!video) return;
      const previous = video;
      video = null;
      previous.pause();
      previous.removeAttribute('src');
      previous.querySelectorAll('source').forEach(source => source.removeAttribute('src'));
      previous.load();
      previous.remove();
    };

    const play = () => {
      const current = video;
      if (!current || !current.isConnected || document.hidden) return;
      current.autoplay = true;
      current.muted = true;
      current.defaultMuted = true;
      if (!current.paused) {
        if (current.readyState >= 2) hero.setAttribute('data-hero-video-playing', '');
        return;
      }
      if (playRequests.has(current)) return;
      const request = current.play();
      playRequests.set(current, request);
      request.then(() => {
        if (video === current && !current.paused) hero.setAttribute('data-hero-video-playing', '');
      }).catch(() => {
        if (video === current && current.paused) hero.removeAttribute('data-hero-video-playing');
      }).finally(() => playRequests.delete(current));
    };

    const select = () => {
      idleRequest = undefined;
      clear();
      const variant = mobile.matches ? 'mobile' : 'desktop';
      const template = hero.querySelector(`[data-hero-video="${variant}"]`);
      if (!template) return;
      const current = template.content.querySelector('video').cloneNode(true);
      const sources = [...current.querySelectorAll('source[data-src]')].sort((a, b) => Number(a.dataset.width) - Number(b.dataset.width));
      const width = hero.clientWidth * Math.min(devicePixelRatio || 1, 2);
      const source = sources.find(item => Number(item.dataset.width) >= width) || sources.at(-1);
      if (!source) return;
      sources.forEach(item => { if (item !== source) item.remove(); });
      // Only the active breakpoint's source enters the DOM and starts downloading.
      source.src = source.dataset.src;
      current.muted = true;
      current.defaultMuted = true;
      current.dataset.variant = variant;
      video = current;
      current.addEventListener('playing', () => {
        if (video === current) hero.setAttribute('data-hero-video-playing', '');
      }, { signal });
      const resume = () => { if (video === current) play(); };
      current.addEventListener('canplay', resume, { signal });
      current.addEventListener('pause', resume, { signal });
      const fallback = () => {
        if (video === current) hero.removeAttribute('data-hero-video-playing');
      };
      current.addEventListener('error', fallback, { signal });
      source.addEventListener('error', fallback, { signal });
      hero.insertBefore(current, hero.querySelector('.oe-static-hero__overlay'));
      play();
    };

    const scheduleSelect = () => {
      const run = () => {
        if ('requestIdleCallback' in window) {
          idleRequest = requestIdleCallback(select, { timeout: 1500 });
        } else {
          idleRequest = setTimeout(select, 0);
        }
      };
      if (document.readyState === 'complete') run();
      else window.addEventListener('load', run, { once: true, signal });
    };

    mobile.addEventListener('change', select, { signal });
    document.addEventListener('visibilitychange', () => { if (!document.hidden) play(); }, { signal });
    window.addEventListener('pageshow', play, { signal });
    instances.set(hero, () => {
      controller.abort();
      if (idleRequest !== undefined) {
        if ('cancelIdleCallback' in window) cancelIdleCallback(idleRequest);
        else clearTimeout(idleRequest);
      }
      clear();
      instances.delete(hero);
    });
    scheduleSelect();
  }

  const initializeWithin = root => root.querySelectorAll('.oe-static-hero').forEach(initialize);
  initializeWithin(document);
  document.addEventListener('shopify:section:load', event => initializeWithin(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('.oe-static-hero').forEach(hero => instances.get(hero)?.());
  });
})();
